"use client";
'use strict';

var React = require('react');

function getCurrentLocation() {
    return {
        pathname: window.location.pathname,
        search: window.location.search,
    };
}
const listeners = [];
/**
 * React hook for window location
 *
 * @example
 * ```javascript
 * const { push, replace, pathname, search } = useLocation()
 * ```
 */
function useLocation() {
    const [{ pathname, search }, setLocation] = React.useState(getCurrentLocation());
    /** All components using the 'useLocation' hook will update. */
    function notify() {
        listeners.forEach((listener) => listener());
    }
    function handleChange() {
        setLocation(getCurrentLocation());
    }
    React.useEffect(() => {
        listeners.push(handleChange);
        window.addEventListener('popstate', handleChange);
        return () => {
            listeners.splice(listeners.indexOf(handleChange), 1);
            window.removeEventListener('popstate', handleChange);
        };
    }, []);
    function push(url) {
        window.history.pushState(null, '', url);
        notify();
    }
    function replace(url) {
        window.history.replaceState(null, '', url);
        notify();
    }
    return {
        push,
        replace,
        pathname,
        search,
    };
}

exports.useLocation = useLocation;
//# sourceMappingURL=useLocation.js.map
